import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import './notice.scss'
import logo1 from '../../../assets/cropped-logo_white.png'
import firebase, { storage } from '../../../utils/firebase'
import Alert from '../Alert';
import { useDispatch, useSelector } from 'react-redux';
import { setNoticeAlert } from '../../../redux/actions/adminActions';
import { getCurrentSubTab } from '../../../redux/actions/adminSideMenuAction';


const NoticePost = () => {

    const [noticeData, setNoticeData] = useState([])
    const [eventsData, setEventsData] = useState([]);
    const [eventTitle, setEventTitle] = useState('');
    const [eventStatus, setEventStatus] = useState('');
    const [eventDate, setEventDate] = useState('');
    const [eventTime, setEventTime] = useState('');
    const [eventID, setEventID] = useState('')
    const [text, setText] = useState('')
    const [color, setColor] = useState('')
    const [edit, setEdit] = useState(false)
    const [status, setStatus] = useState('')
    const [editId, setEditId] = useState('')
    const [deleteId, setDeleteId] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const alert = useSelector(state => state.alert)
    const { noticeAlertStatus } = alert
    const dispatch = useDispatch()
    const [deleting, setDeleting] = useState(false)
    const [cloning, setCloning] = useState(false)
    const [cloneId, setCloneId] = useState('')

    useEffect(() => {
        dispatch(getCurrentSubTab('notice'))
    }, [dispatch])

    useEffect(() => {
        const eventRef = firebase.database().ref('Events')

        eventRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }

            if (eData.length !== eventsData.length) {
                setEventsData(eData)
            } else {
                for (let i = 0; eData.length < i; i++) {
                
                    if (eData[i] !== eventsData[i]) {
                        
                    };
                }
            }

            

            
        })

        const check = eventsData.some(el => {
            return el.eventStatus === 'Live'
        })

        if(check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Live') {
                    setEventTitle(el.eventName)
                    setEventDate(el.eventDate)
                    setEventTime(el.eventTime)
                    setEventStatus(el.eventStatus)
                    setEventID(el.id)
                    return
                }
            })
        }
        if (!check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Default') {
                    setEventTitle(el.eventName)
                    setEventDate(el.eventDate)
                    setEventTime(el.eventTime)
                    setEventStatus(el.eventStatus)
                    setEventID(el.id)
                    return
                }
            })             
        }
        // console.log(typeof eventData[1].eventStatus)
    }, [eventsData])

    useEffect(() => {
        if (eventID) {
            const noticeRef = firebase.database().ref('Events').child(eventID).child('Notice')
            noticeRef.on('value', (el) => {
                let eData = []
                for (let id in el.val()) {
                    eData.push({id, ...el.val()[id]})
                }
                setNoticeData(eData)
            })
        }
        
    }, [eventID])

    useEffect(() => {
        if (noticeAlertStatus) {
            if(deleteId) {
                const noticeRef = firebase.database().ref('Events').child(eventID).child('Notice').child(deleteId)
                noticeRef.remove()
                dispatch(setNoticeAlert(false))
                setDeleteId('')
                setDeleting(false)
            }
            
        }
    }, [deleteId, dispatch, noticeAlertStatus])

    const handleOpenNoticeForm = () => {
        document.querySelector('.admin-background').classList.remove('hide')
        document.querySelector('.notice-form-container').classList.remove('hide')
        document.querySelector(`.admin-nav`).scrollIntoView(); 
    }

    const handleCloseNoticeForm = (e) => {
        e.preventDefault()
        document.querySelector('.admin-background').classList.add('hide')
        document.querySelector('.notice-form-container').classList.add('hide')
        setEdit(false)
        setEditId('')
        setText('')
        setColor('')
        setStatus('')
    }

    const handleShowHide = (id) => {
        let savedStatus = ''
        const noticeRef = firebase.database().ref('Events').child(eventID).child('Notice').child(id)
        noticeRef.once('value', (el) => {
            savedStatus =  el.val().status
            })
        let newNotice = {    
                status: savedStatus === 'Hidden'? 'Showing' : savedStatus === 'Showing'? 'Hidden': 'something wrong',
                updatedAtDate: Date.now()
            }
        noticeRef.update(newNotice)
    }

    const handleNoticeDelete = (id, index) => {
        // setPageState(activePage)
        setDeleting(true)
        setDeleteId(id)
        setAlertMessage(`Are you sure you want to delete this notice?`)
        document.querySelector(`.a${id}`).classList.remove('hide')
        let elmnt = document.querySelector(".content-view");
        let y = elmnt.scrollHeight;
        document.querySelector('.admin-background').style.height = `${y + 110}px`
        document.querySelector('.admin-background').classList.remove('hide')
        
        if((index + 1) >= 4) {
            document.querySelector(`.a${id}`).scrollIntoView();   
        }
    }

    const handleNoticeEdit = (id) => {
        setEdit(true)
        setEditId(id)
        const noticeRef = firebase.database().ref('Events').child(eventID).child('Notice').child(id)
        noticeRef.on('value', (el) => {
            setText(el.val().text)
            setColor(el.val().color + ' ' + el.val().colorName)
            setStatus(el.val().status)
            })

        document.querySelector('.admin-background').classList.remove('hide')
        document.querySelector('.notice-form-container').classList.remove('hide')
        document.querySelector(`.admin-nav`).scrollIntoView();  
    }

    const handleNoticeClone = (id) => {
        setCloneId(id)
    }

useEffect(() => {
    if(cloning && cloneId) {
        const allNoticeRef = firebase.database().ref('Events').child(eventID).child('Notice')
        const noticeRef = firebase.database().ref('Events').child(eventID).child('Notice').child(cloneId)
        noticeRef.once('value', (el) => {
            let newNotice = {    
                text: el.val().text,
                color: el.val().color,
                colorName: el.val().colorName,
                status: el.val().status,
                createdAtDate: Date.now()
            }
            allNoticeRef.push(newNotice)
        })
        setCloning(false)
        setCloneId('')
    }
    
}, [cloneId, cloning, eventID])

    

    const handleUpdateNoticeForm = (e) => {
        e.preventDefault()
        if(!text || !color || !status) {
            return
        }

        const noticeRef = firebase.database().ref('Events').child(eventID).child('Notice').child(editId)
        let newNotice = {    
                text: text,
                color: color.split(' ')[0],
                colorName: color.split(' ')[1],
                status: status,
                updatedAtDate: Date.now()
            }
        

        noticeRef.update(newNotice)
        setText('')
        setColor('')
        setStatus('')
        document.querySelector('.admin-background').classList.add('hide')
        document.querySelector('.notice-form-container').classList.add('hide')
    }

    const handleSubmitNoticeForm = (e) => {
        e.preventDefault()
        if(!text || !color || !status) {
            return
        }

        const noticeRef = firebase.database().ref('Events').child(eventID).child('Notice')
        let newNotice = {    
                text: text,
                color: color.split(' ')[0],
                colorName: color.split(' ')[1],
                status: status,
                createdAtDate: Date.now()
            }
        

        noticeRef.push(newNotice)
        setText('')
        setColor('')
        setStatus('')
        document.querySelector('.admin-background').classList.add('hide')
        document.querySelector('.notice-form-container').classList.add('hide')
    }

    return (
        <div className="notice-post events-view">
            <Helmet htmlAttributes>
                <meta charSet="utf-8" />
                <html lang="en" />
                <title>Admin-Notice Post | LVZConnect</title>
                <meta name="description" content="LVZConnect Admin Languages Page" />
            </Helmet>
            <div className="top">
                <div>
                    <img src={logo1} alt="" />
                    <h3>NOTICE POST</h3>
                </div>
                
                <button onClick={handleOpenNoticeForm}>New Notice +</button>
            </div>
            <div className="event-details">
                {eventTitle && eventStatus? 
                    <>
                        <p>Event Name: <span>{eventTitle}</span></p>
                        <p>Date of Event: <span>{eventDate} / {eventTime}</span></p>
                        {eventStatus === 'Live'? 
                            <p>Event Status: <span className='live'>{eventStatus}</span></p>
                            : <p>Event Status: <span className='not-live'>{eventStatus}</span></p>
                        }
                    </>
                    :

                    <>
                        <p>Event Name:</p>
                        <p>Date of Event:</p>
                        <p>Event Status: </p>      
                    </>
                
                }
                
                
            </div>
            <div className="table-container">
                <div className="table title">
                    <div className="num dd">#</div>
                    <div className="text dd">Text</div>
                    <div className="color dd">Color</div>
                    <div className="n-status dd">Status</div>
                    <div className="t-stamp dd">Date Time Stamp</div>
                    <div className="m-btn dd">Management Buttons</div>
                </div> 

                {noticeData.map((el, i) => {
                    return (
                        <div className="table ">
                            <Alert message={alertMessage} eventId={el.id} action={setNoticeAlert} />
                            <div className="num dd">{i + 1}</div>
                            <div className="text dd">{el.text}</div>
                            <div className="color cc dd" style={{color: `${el.color}`}}>{el.colorName}</div>
                            <div className="n-status ss dd">{el.status}</div>
                            <div className="t-stamp dd">{new Date(el.createdAtDate).toLocaleString()}</div>
                            <div className="m-btn dd">
                                <button className='view-details' title='Toggle Status' onClick={()=> handleShowHide(el.id)}><i class="far fa-eye"></i></button>
                                <button className='delete' title='Delete' onClick={()=> handleNoticeDelete(el.id, i)}><i class="fas fa-trash-alt"></i></button>
                                <button className='edit' title='Edit' onClick={()=> handleNoticeEdit(el.id)}><i class="fas fa-edit"></i></button>
                                <button className='clone' title='Clone' onClick={() => {
                                        setCloning(true)
                                    handleNoticeClone(el.id)}}><i class="far fa-copy"></i></button>
                            </div>
                        </div>
                    )
                })}

            </div>


            <div className='notice-form-container hide'>
                <div className="form-close" onClick={handleCloseNoticeForm}>
                    <i class="fas fa-times"></i>
                </div>
                <h3>
                    {edit? 'Edit Notice' : 'Add New Notice'}
                </h3>

                <form action="">
                    <div className="form-element">
                        <label htmlFor="n-text">Text<span>*</span></label>
                        <textarea  required type="text" id='n-text' name='n-text' className='field' 
                        value={text} onChange={(e) => setText(e.target.value)}/>
                    </div>

                    <div className="form-element">
                        <label htmlFor="n-color">Color<span>*</span></label>
                        <select required className='field' name="n-color" id="n-color" value={color} onChange={(e) => setColor(e.target.value)}>
                            <option value=""></option>
                            <option value="#FFFFFF White">White</option>
                            <option value="#dba860 Gold">Gold</option>
                            <option value="#2BE90C Florescent-Green">Florescent Green</option>
                            <option value="#F2E601 Florescent-Yellow">Florescent Yellow</option>
                            <option value="#FFBF00 Florescent-Orange">Florescent Orange</option>
                            <option value="#019AF2 Florescent-Blue">Florescent Blue</option>
                            <option value="#F201DF Florescent-Pink">Florescent Pink</option>
                            <option value="#F20101 Florescent-Red">Florescent Red</option>
                        </select> 
                    </div>

                    <div className="form-element">
                        <label htmlFor="n-status">Status<span>*</span></label>
                        <select required className='field' name="n-status" id="n-status" value={status} onChange={(e) => setStatus(e.target.value)}>
                            <option value=""></option>
                            <option value="Hidden">Hidden</option>
                            <option value="Showing">Showing</option>
                        </select>
                       
                    </div>

                    {/* <div className='upload-status'>
                        <p>Status:</p>
                        {uploadStage === 'loading'? <p className="loading">{uploadProgress}</p> : uploadStage === 'fail'? <p className="fail">{uploadProgress}</p> : ''}
                        
                    </div>  */}

                    <div className="buttons">
                        <button className="close" onClick={handleCloseNoticeForm}>Close</button>
                        {edit? <button type="submit"  className='submit' onClick={(e) => handleUpdateNoticeForm(e, editId)}>Update Notice</button> : <button type="submit"  className='submit' onClick={handleSubmitNoticeForm}>Save Notice</button>}
                    </div>

                    
                </form>
            </div>
        </div>
    )
}

export default NoticePost